import { FC, useMemo, useState, useTransition } from "react";
import { FolderContainer, FolderItem, FolderTagContainer } from "../../tabs/styles";
import { Dropdown, DropdownListItem, FlexBox, HintTooltip, useBreakpoint, useToasts } from "@brg/ui";
import { ScrollWrapper, TagsTitleWrapper } from "./designerTagsCloud";
import useQueryState from "shared/hooks/useQueryState";
import { MoreButton } from "shared/components/more-button";
import { useTranslation } from "react-i18next";
import { bTag, LayoutConst, useModal } from "core";
import { FOLDERS_MODE, FolderT } from "../../tabs/const";
import { ProfileUtils, useProfile } from "@brg/auth";
import PlusSvg from "shared/assets/32/PlusSvg";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import { useTheme } from "styled-components";
import ProfileFoldersSlice, { ProfileFoldersProps, ProfileFoldersSelector } from "shared/reducers/ProfileFoldersSlice";
import { useDispatch, useSelector } from "react-redux";
import { BTag } from "core/components";

export const FoldersTabs: FC<{ 
    tabs?:FolderT[] ,
    designerId?: string, 
    hideCloud?: boolean,
    isMe?: boolean,
    activeId?: string, 
    update?: any,
    setTagId?: (id?: string | undefined) => void 
}> = ({ tabs, designerId, hideCloud, update, activeId, isMe, setTagId }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const dispatch = useDispatch();
    const { info, error } = useToasts();
    const profile = useProfile();
    const isTab = useBreakpoint(LayoutConst.screen.m);
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );
    const [ {  folderId }, setQueryParams ]  = useQueryState();
    const currentFolder = useSelector(ProfileFoldersSelector)?.currentFolder;
    const cloudVisible = useSelector(ProfileFoldersSelector)?.cloudVisible;
    const isModer = useMemo(() => profile && ProfileUtils.isModer(profile),[profile]);
    
    const canEdit = useMemo(() => isMe , [isModer, isMe])

    const canVisibleWithLink = (fl: FolderT) => {
        return !!fl?.isHidden && folderId == fl?.id;
    }

    const onFolderChange = (s:ProfileFoldersProps, fId?: string) => {
        if (fId && activeId && fId === activeId) {
            setQueryParams({ folderId: undefined })
            return
        }
        if (fId) {
            setQueryParams({ folderId: fId })
        }
        if (currentFolder === ProfileFoldersProps.cloud) {
            dispatch(ProfileFoldersSlice.actions.setCurrentFolder(ProfileFoldersProps.projects))
        }
        dispatch(ProfileFoldersSlice.actions.setCurrentFolder(s))
        setTagId && setTagId(undefined)
    }

    const onTagsButtonClick = () => {
        currentFolder === ProfileFoldersProps.cloud ? 
            onFolderChange(ProfileFoldersProps.projects) : 
            onFolderChange(ProfileFoldersProps.cloud)
            setQueryParams({ folderId: undefined })
        return;
    }

    const folders = useMemo(() => {
        if (!tabs?.length) return null;

        return tabs?.filter((tab) => {
            if (isMe || canVisibleWithLink(tab)) {
                return tab
            }  
            return !tab?.isHidden;
        })?.map(({ name, id }, idx) => {
            return (
                <FolderContainer key={`folders_${idx}`}>
                    <BTag
                        isShort
                        isTagsCloud 
                        onClick={() => onFolderChange(ProfileFoldersProps.projects, id)}
                        isFolder
                        selected={id === activeId}
                    >   
                        <TagsTitleWrapper gx={8}>
                            {name}
                        </TagsTitleWrapper>
                    </BTag>
                </FolderContainer>
            )
        })
 
    } , [tabs, update, activeId, isMe, designerId])

    const addButton = useMemo(() => {

        if (!canEdit) return null;

        return (
            <FolderTagContainer>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("hints.create_folder")} 
                    z={3} 
                    noDisappearDelay 
                    positionY="default"
                    onWhiteBg
                    /*{...tooltipProps}*/
                  >
                    <BTag
                        key={`folders_create`}
                        isShort
                        isTagsCloud
                        isFolder
                        isCreateAction 
                        onClick={() => {
                            onFolderChange(
                                currentFolder === ProfileFoldersProps.cloud ? 
                                ProfileFoldersProps.create : 
                                ProfileFoldersProps.cloud 
                            )
                            setQueryParams({ folderId: undefined })
                        }}
                    >

                        {isTab ? (
                            <FlexBox gx={10} gxMobile={10}>
                                <PlusSvg />
                                <TagsTitleWrapper>{t('folders.modal.create_folder')}</TagsTitleWrapper>
                            </FlexBox>
                        ) : (
                            <PlusSvg />
                        )}
                    </BTag>
                </HintTooltip>
                </FolderTagContainer>
        )
    }, [canEdit, i18n.language, currentFolder, isTab])

    const tagsButton = useMemo(() => {
        if (!cloudVisible) return null;

        const importantColor = '#545453';
        return (
                <FolderItem
                    // folder
                    onClick={onTagsButtonClick}
                    importantColor={importantColor}
                    selected={currentFolder === ProfileFoldersProps.cloud}
                >
                    <TagsTitleWrapper>{t('folders.modal.tags_button')}</TagsTitleWrapper>
                </FolderItem>
        )
    }, [currentFolder, cloudVisible])

    return (
        // <FlexBox 
        //     direction="column" 
        //     // offsetTop={tabs?.length || !hideCloud || canEdit ? 16 : 1} 
        //     // offsetTopMobile={isMobile ? 1 : 16}
        //     directionMobile="column" 
        //     width='100%'
        // >
        //     <ScrollWrapper 
        //         overflowVisible 
        //         hideBottomLine
        //     >
        //         {/* {tagsButton} */}
        //         {addButton}
        //         {folders}
        //     </ScrollWrapper>
        // </FlexBox>
        <>
            {addButton}
            {folders}
        </>
    )
}import { FC, useMemo, useState, useTransition } from "react";
import { FolderContainer, FolderItem, FolderTagContainer } from "../../tabs/styles";
import { Dropdown, DropdownListItem, FlexBox, HintTooltip, useBreakpoint, useToasts } from "@brg/ui";
import { ScrollWrapper, TagsTitleWrapper } from "./designerTagsCloud";
import useQueryState from "shared/hooks/useQueryState";
import { MoreButton } from "shared/components/more-button";
import { useTranslation } from "react-i18next";
import { bTag, LayoutConst, useModal } from "core";
import { FOLDERS_MODE, FolderT } from "../../tabs/const";
import { ProfileUtils, useProfile } from "@brg/auth";
import PlusSvg from "shared/assets/32/PlusSvg";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import { useTheme } from "styled-components";
import ProfileFoldersSlice, { ProfileFoldersProps, ProfileFoldersSelector } from "shared/reducers/ProfileFoldersSlice";
import { useDispatch, useSelector } from "react-redux";
import { BTag } from "core/components";

export const FoldersTabs: FC<{ 
    tabs?:FolderT[] ,
    designerId?: string, 
    hideCloud?: boolean,
    isMe?: boolean,
    activeId?: string, 
    update?: any,
    setTagId?: (id?: string | undefined) => void 
}> = ({ tabs, designerId, hideCloud, update, activeId, isMe, setTagId }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const dispatch = useDispatch();
    const { info, error } = useToasts();
    const profile = useProfile();
    const isTab = useBreakpoint(LayoutConst.screen.m);
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );
    const [ {  folderId }, setQueryParams ]  = useQueryState();
    const currentFolder = useSelector(ProfileFoldersSelector)?.currentFolder;
    const cloudVisible = useSelector(ProfileFoldersSelector)?.cloudVisible;
    const isModer = useMemo(() => profile && ProfileUtils.isModer(profile),[profile]);
    
    const canEdit = useMemo(() => isMe , [isModer, isMe])

    const canVisibleWithLink = (fl: FolderT) => {
        return !!fl?.isHidden && folderId == fl?.id;
    }

    const onFolderChange = (s:ProfileFoldersProps, fId?: string) => {
        if (fId && activeId && fId === activeId) {
            setQueryParams({ folderId: undefined })
            return
        }
        if (fId) {
            setQueryParams({ folderId: fId })
        }
        if (currentFolder === ProfileFoldersProps.cloud) {
            dispatch(ProfileFoldersSlice.actions.setCurrentFolder(ProfileFoldersProps.projects))
        }
        dispatch(ProfileFoldersSlice.actions.setCurrentFolder(s))
        setTagId && setTagId(undefined)
    }

    const onTagsButtonClick = () => {
        currentFolder === ProfileFoldersProps.cloud ? 
            onFolderChange(ProfileFoldersProps.projects) : 
            onFolderChange(ProfileFoldersProps.cloud)
            setQueryParams({ folderId: undefined })
        return;
    }

    const folders = useMemo(() => {
        if (!tabs?.length) return null;

        return tabs?.filter((tab) => {
            if (isMe || canVisibleWithLink(tab)) {
                return tab
            }  
            return !tab?.isHidden;
        })?.map(({ name, id }, idx) => {
            return (
                <FolderContainer key={`folders_${idx}`}>
                    <BTag
                        isShort
                        isTagsCloud 
                        onClick={() => onFolderChange(ProfileFoldersProps.projects, id)}
                        isFolder
                        selected={id === activeId}
                    >   
                        <TagsTitleWrapper gx={8}>
                            {name}
                        </TagsTitleWrapper>
                    </BTag>
                </FolderContainer>
            )
        })
 
    } , [tabs, update, activeId, isMe, designerId])

    const addButton = useMemo(() => {

        if (!canEdit) return null;

        return (
            <FolderTagContainer>
                <HintTooltip 
                    //@ts-ignore
                    customStyle={getTooltipStyles(theme)} 
                    text={t("hints.create_folder")} 
                    z={3} 
                    noDisappearDelay 
                    positionY="default"
                    onWhiteBg
                    /*{...tooltipProps}*/
                  >
                    <BTag
                        key={`folders_create`}
                        isShort
                        isTagsCloud
                        isFolder
                        isCreateAction 
                        onClick={() => {
                            onFolderChange(
                                currentFolder === ProfileFoldersProps.cloud ? 
                                ProfileFoldersProps.create : 
                                ProfileFoldersProps.cloud 
                            )
                            setQueryParams({ folderId: undefined })
                        }}
                    >

                        {isTab ? (
                            <FlexBox gx={10} gxMobile={10}>
                                <PlusSvg />
                                <TagsTitleWrapper>{t('folders.modal.create_folder')}</TagsTitleWrapper>
                            </FlexBox>
                        ) : (
                            <PlusSvg />
                        )}
                    </BTag>
                </HintTooltip>
                </FolderTagContainer>
        )
    }, [canEdit, i18n.language, currentFolder, isTab])

    const tagsButton = useMemo(() => {
        if (!cloudVisible) return null;

        const importantColor = '#545453';
        return (
                <FolderItem
                    // folder
                    onClick={onTagsButtonClick}
                    importantColor={importantColor}
                    selected={currentFolder === ProfileFoldersProps.cloud}
                >
                    <TagsTitleWrapper>{t('folders.modal.tags_button')}</TagsTitleWrapper>
                </FolderItem>
        )
    }, [currentFolder, cloudVisible])

    return (
        // <FlexBox 
        //     direction="column" 
        //     // offsetTop={tabs?.length || !hideCloud || canEdit ? 16 : 1} 
        //     // offsetTopMobile={isMobile ? 1 : 16}
        //     directionMobile="column" 
        //     width='100%'
        // >
        //     <ScrollWrapper 
        //         overflowVisible 
        //         hideBottomLine
        //     >
        //         {/* {tagsButton} */}
        //         {addButton}
        //         {folders}
        //     </ScrollWrapper>
        // </FlexBox>
        <>
            {addButton}
            {folders}
        </>
    )
}